import { SEMANTIC_EVENT_NAME, TOPIC_TAG_TXT, TRIGGER_LOCATION, TRIGGER_TYPE } from './globals';
import { trackEvent } from '../../analytics';

const EXTERNAL_LINK_WARNING_MODAL = 'external_link_warning_modal';
const EVENT_TEMPLATE_ID = '171';

// https://dataportal.zillowgroup.net/event-registry/8888
export const emitOpenExternalLinkWarningModalEvent = () =>
  trackEvent({
    envelope: {
      event_type_id: '8888',
      event_type_version_id: '1',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Impression,
      trigger_location_nm: TRIGGER_LOCATION.RachelInbox,
      trigger_source_nm: EXTERNAL_LINK_WARNING_MODAL,
      trigger_object_nm: 'click_external_link',
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ViewContent,
      topic_tag_txt: [TOPIC_TAG_TXT.RachelSatellite],
    },
  });

// https://dataportal.zillowgroup.net/event-registry/8889
export const emitExternalLinkClickedInExternalLinkWarningModalEvent = () =>
  trackEvent({
    envelope: {
      event_type_id: '8889',
      event_type_version_id: '1',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.RachelInbox,
      trigger_source_nm: 'external_link',
      trigger_object_nm: EXTERNAL_LINK_WARNING_MODAL,
    },
    semantic: {
      semantic_event_nm: 'external_link_warning',
      topic_tag_txt: [TOPIC_TAG_TXT.RachelSatellite],
    },
  });
